export default __webpack_public_path__ + "static/media/lookup-help-white.8a0865ba.png";